<template lang="pug">
div
  banner
  section.annouce-sec(data-bs-toggle='modal' data-bs-target='#popup-ann')
    .max-container
      .annouce-wrapper
        .annouce-img
          img(src='/images/megaphone.png')
        .annouce-text
          marquee(scrolldelay='100' v-html="$t('ui.marquee.announcement', { url: getUrl() })")
  liveTrans(v-if="!liveFooter")
  .m-access(v-if="!isLoggedIn")
    button.login-btn(type='button' @click="$router.push('/login').catch(err => {})") {{$t('ui.login')}}
    button.login-btn.reg(type='button' @click="$router.push('/register').catch(err => {})")
      p.animate__animated.animate__heartBeat.animate__infinite {{$t('ui.register')}}
  .af-quickmenu-content(v-if="isLoggedIn")
    .af-quickmenu-wrapper
      div
        .bal
          div
            .af-user {{ $t('ui.hi') }} {{ getDisplayName }} 
              span(v-if="$store.getters.username") ({{$store.getters.accountID}})
            .af-bal {{$t('ui.current_balance')}}
            .baltext
              span.myr-num(@click="$router.push('/deposit').catch(err => {})") RM {{$numeral(currentBalance).format("0,0.00")}}
              a.reload-mw(href="javascript:void(0)" @click="getBalance")
                i.fa-solid.fa-rotate-right
            //- template(v-if="$helpers.timingControl('2025-04-16 00:00', '2025-05-31 23:59')")
              .af-bal Epic Lucky Spin Token:
              .baltext(style="color:yellow")
                span.myr-num.pointer(@click="$router.push('/lucky-spin').catch(err => {})") {{spintokenBal}}
                a.reload-mw.reload-right(href="javascript:void(0)" @click="$router.push('/lucky-spin').catch(err => {})")
                  i.fa-solid.fa-chevron-right
          .baldepo
            router-link(to="/deposit")
              img(src='/images/deposit.gif')
        .af-menu
          .restore-center
            router-link(to="/deposit")
              img(src='/images/menu/af-deposit.png')
              .restext Deposit
          .restore-center
            router-link(to="/statement")
              img(src='/images/menu/af-history.png')
              .restext History
          .restore-center
            router-link(to="/withdrawal")
              img(src='/images/menu/af-withdraw.png')
              .restext {{$t('ui.withdrawal')}}
          .restore-center
            router-link(to="/promotions")
              img(src='/images/menu/af-bonus.png')
              .restext Bonus
          .restore-center
            router-link(to="/referral")
              img(src='/images/menu/af-refer.png')
              .restext Referral
  .checkinbox.home.pointer(@click="triggerAction(true)")
    .ttitle
      img(src='assets/img/check-in/title.png')
    //- .subtitle Deposit & Earn MYR 300
    .ci-wrapper
      template(v-for="(data, index) in dataDay")
        //- .cib.pointer(:class="[{'claimed' : data.claimed===true}, {'ready' : data.ready === true}]" @click="triggerAction(data.ready)")
        .cib.pointer(:class="[{'claimed' : data.claimed===true}, {'ready' : data.ready === true}]")
          .ci-date(v-if="data.claimed")
            span {{ data.date }}
          .bbg
            img(src='assets/img/check-in/unlock.png')
          .tt {{data.day}}
          //- .amount(v-if="data.claimed") {{ data.date }}
          //- .iimg
            img(:src="'assets/img/check-in/c'+(index+1)+'.png'")
      .cibfs
        i.fa-solid.fa-plus
        .bbg
          img(src="assets/img/check-in/freespin-tb.png")
    .progress(v-if="isLoggedIn")
      //- template(v-for="(data, index) in dataDay")
      .pdot.p1(:class="{'active': dataDay[0].claimed === true}")
      .pdot.p2(:class="{'active': dataDay[1].claimed === true}")
      .pdot.p3(:class="{'active': dataDay[2].claimed === true}")
      .pdot.p4(:class="{'active': dataDay[3].claimed === true}")
      .pdot.p5(:class="{'active': dataDay[4].claimed === true}")
      .progress-bar(role="progressbar" :style="'width:'+getClaimed+'%'")
  .t-content
    section.mobile-home
      .m-container
        .game-tab-wrapper
          .gamenav-slide
            a#slots-tab.nav-link(href="javascript:void(0)" :class="{'active' : selectedTab == 0}" @click="switchTab(0)")
              .hm-icon
                img(src='/images/menu/c-slot.png')
              div {{$t('ui.slotgames')}}
            a.nav-link(href="javascript:void(0)" @click="$router.push('/partners').catch(err => {})")
              .hm-icon
                img(src='/images/menu/c-partner.png')
              div {{$t('ui.partner')}}
            a#casino-tab.nav-link(href="javascript:void(0)" @click="$router.push('/live').catch(err => {})")
              .hm-icon
                img(src='/images/menu/c-live.png')
              div {{$t('ui.live')}}
            a.nav-link(href="javascript:void(0)" @click="$router.push('/fish').catch(err => {})")
              .hm-icon
                img(src='/images/menu/c-fish.png')
              div {{$t('ui.fish')}}
            a.nav-link(href="javascript:void(0)" @click="$router.push('/poker').catch(err => {})")
              .hm-icon
                img(src='/images/menu/c-poker.png')
              div {{$t('ui.poker')}}
            a.nav-link(href="javascript:void(0)" @click="$router.push('/minigame').catch(err => {})")
              .hm-icon
                img(src='/images/menu/c-game.png')
              div {{$t('ui.minigame')}}
            //- a.nav-link(href="javascript:void(0)" @click="$router.push('/vip').catch(err => {})")
              .hm-icon
                img(src='/images/menu/c-vip.png')
              div VIP
            a.nav-link(href="javascript:void(0)" @click="$router.push('/promotions').catch(err => {})")
              .hm-icon
                img(src='/images/menu/c-bonus.png')
              div Bonus
            a.nav-link(href="javascript:void(0)" @click="$router.push('/reviews').catch(err => {})")
              .hm-icon
                img(src='/images/menu/c-rank.png')
              div {{$tc('ui.leaderboard')}}
            a.nav-link(href="javascript:void(0)" @click="$router.push('/lottery').catch(err => {})")
              .hm-icon
                img(src='/images/menu/c-4d.png')
              div Lottery
            a.nav-link(href="javascript:void(0)" @click="$router.push('/referral').catch(err => {})")
              .hm-icon
                img(src='/images/menu/c-refer.png')
              div Referral
            a.nav-link(href="javascript:void(0)" @click="$router.push('/freeplay').catch(err => {})")
              .hm-icon
                img(src='/images/menu/c-free.png')
              div {{$t('ui.demoplay')}}
            a.nav-link(href="javascript:void(0)" @click="$router.push('/news').catch(err => {})")
              .hm-icon
                img(src='/images/menu/c-blog.png')
              div {{$tc('ui.news')}}
          .tab-content.game-content
            #slot.tab-pane(v-if="" :class="{'active': selectedTab === 0}")
              slotLobby
            //- #casino.tab-pane(:class="{'active': selectedTab === 1}")
              livecasino
            #sports.tab-pane
              .dropdown-wrapper.mobile-game
                a(href='#')
                  .pvd-img
                    img(src='/images/products/epicwin.png')
            #fishing.tab-pane
              .dropdown-wrapper.mobile-game
                a(href='#')
                  .pvd-img
                    img(src='/images/products/epicwin.png')
    section.sports-highlight-sec
      .max-container
        .title-wrap
          span.title-text {{$t('ui.slotgames')}}
          //- .search-wrap
            .search-box
              span.search-icon
                i.fas.fa-search
              input.search-input(type='text' placeholder='Search')
        .slot-highlight-wrapper
          .slot-slide
            .slotsbox
              a(href="javascript:void(0)" @click="toSlot(0)")
                img(src='/images/products/epicwin.png')
            .slotsbox
              img.game-hot(src='/images/hot.png')
              a(href="javascript:void(0)" @click="toSlot(1)")
                img(src='/images/products/megah5.png')
            .slotsbox
              img.game-new(src='/images/new.png')
              a(href="javascript:void(0)" @click="toSlot(2)")
                img(src='/images/products/pragmatic.png')
            .slotsbox
              img.game-hot(src='/images/hot.png')
              a(href="javascript:void(0)" @click="toSlot(3)")
                img(src='/images/products/jili.png')
            .slotsbox
              a(href="javascript:void(0)" @click="toSlot(4)")
                img(src='/images/products/live22.png')
            .slotsbox
              img.game-new(src='/images/new.png')
              a(href="javascript:void(0)" @click="toSlot(26)")
                img(src='/images/products/hacksaw.png')
            .slotsbox
              img.game-new(src='/images/new.png')
              a(href="javascript:void(0)" @click="toSlot(24)")
                img(src='/images/products/bng.png')
        //- .title-wrap
          span.title-text Players Favourite
        //- .slot-highlight-wrapper
          .slot-slide
            .slotsbox
              img.game-fav(src='/images/fav.png')
              a(href='#')
                img(src='/images/thumb/s1.png')
            .slotsbox
              img.game-fav(src='/images/fav.png')
              a(href='#')
                img(src='/images/thumb/s2.png')
            .slotsbox
              img.game-fav(src='/images/fav.png')
              a(href='#')
                img(src='/images/thumb/s3.png')
            .slotsbox
              img.game-fav(src='/images/fav.png')
              a(href='#')
                img(src='/images/thumb/s4.png')
            .slotsbox
              img.game-fav.nonfav(src='/images/fav.png')
              a(href='#')
                img(src='/images/thumb/s5.png')
            .slotsbox
              img.game-fav.nonfav(src='/images/fav.png')
              a(href='#')
                img(src='/images/thumb/s6.png')
            .slotsbox
              img.game-fav.nonfav(src='/images/fav.png')
              a(href='#')
                img(src='/images/thumb/s1.png')
        .title-wrap
          span.title-text Live Casino
        .slot-highlight-wrapper
          .slot-slide
            .slotsbox
              router-link(to="/live")
                img(src='/images/thumb/l1.png')
            .slotsbox
              router-link(to="/live")
                img(src='/images/thumb/l2.png')
            .slotsbox
              router-link(to="/live")
                img(src='/images/thumb/l3.png')
            .slotsbox
              router-link(to="/live")
                img(src='/images/thumb/l4.png')
            .slotsbox
              router-link(to="/live")
                img(src='/images/thumb/l5.png')
            .slotsbox
              router-link(to="/live")
                img(src='/images/thumb/l6.png')
    liveTrans.rtt-footer(v-if="liveFooter")
    section.faq
      .max-container
        .title-wrap
          span.title-text FAQ
        #accordion
          .tnc-card
            button.btn-tnc.collapsed(data-bs-toggle='collapse' data-bs-target='#tnc1' aria-expanded='false' aria-controls='tnc1')
              | 1. How do I get free credit RM10 at epicwin?
            #tnc1.collapse(aria-labelledby='headingOne' data-bs-parent='#accordion' style='')
              .tnc-body
                p
                  | Claiming free credit RM10 on EpicWin is easy! All you have to do is sign up for a free account and look for the Welcome Bonus at the Promotions page. You&apos;ll be credited with RM10 once your registration is confirmed. Start your EPIC winning journey today &mdash; spin and get ready to win big!
          .tnc-card
            button.btn-tnc.collapsed(data-bs-toggle='collapse' data-bs-target='#tnc2' aria-expanded='false' aria-controls='tnc2')
              | 2. What is the best Ewallet Casino in Malaysia to claim free credit?
            #tnc2.collapse(aria-labelledby='headingOne' data-bs-parent='#accordion' style='')
              .tnc-body
                p
                  | EpicWin is the best eWallet casino in Malaysia to claim free credits - if you&apos;re looking for an exciting, secure, and reliable online slot experience, EpicWin is your answer. With our game slot free credit offers, you can start playing right away without having to worry about making any deposits. Claim your free credit now and get ready to start your EPIC winning journey!
          .tnc-card
            button.btn-tnc.collapsed(data-bs-toggle='collapse' data-bs-target='#tnc3' aria-expanded='false' aria-controls='tnc3')
              | 3. Is it legal to play mobile slot games in Malaysia?
            #tnc3.collapse(aria-labelledby='headingOne' data-bs-parent='#accordion' style='')
              .tnc-body
                p
                  | Yes, playing slot games on EpicWin is perfectly legal in Malaysia. We understand the importance of offering a safe and secure gambling experience to our players, which is why our casino only features verified licensed game providers with legally certified slots. Rest assured that when you play here, your gaming experience is completely secure and safe.
          .tnc-card
            button.btn-tnc.collapsed(data-bs-toggle='collapse' data-bs-target='#tnc4' aria-expanded='false' aria-controls='tnc4')
              | 4. How do I use my Win88 Wallet?
            #tnc4.collapse(aria-labelledby='headingOne' data-bs-parent='#accordion' style='')
              .tnc-body
                p
                  | EpicWin&rsquo;s Win88 Wallet has been tailored to meet online casino players&rsquo; needs &mdash; from a simple and secure way to deposit funds, to a fast and efficient way to withdraw winnings. To use your Win88 Wallet, simply follow the step-by-step instructions displayed in the EpicWin app. From there, you&rsquo;ll be able to add funds to your account, withdraw them, get game slot free credit offers, and more! With EpicWin, EPIC wins are just a few clicks away!
          .tnc-card
            button.btn-tnc.collapsed(data-bs-toggle='collapse' data-bs-target='#tnc5' aria-expanded='false' aria-controls='tnc5')
              | 5. How to avail Win88 Wallet Free Credit?
            #tnc5.collapse(aria-labelledby='headingOne' data-bs-parent='#accordion' style='')
              .tnc-body
                p
                  | It&rsquo;s easy! With EpicWin, you can easily avail of the Win88 Wallet Free Credit just by signing up. After signing up, simply head to &lsquo;My Wallet&rsquo; and claim your free credit. Once claimed, you can use this free credit on any game slot of your choice and start playing games for real cash money wins!
          .tnc-card
            button.btn-tnc.collapsed(data-bs-toggle='collapse' data-bs-target='#tnc6' aria-expanded='false' aria-controls='tnc6')
              | 6. How does EpicWin differ from other online casinos in Malaysia?
            #tnc6.collapse(aria-labelledby='headingOne' data-bs-parent='#accordion' style='')
              .tnc-body
                p
                  | EpicWin offers a unique experience with exclusive bonus offers and rewards. Our free credit welcome bonus is one of the biggest in the industry, which makes the signup process extremely rewarding. We also have ongoing promotions and VIP rewards that give you an extra edge when playing games. So sign up today and get ready to make some Epic Wins!
        br
        br
        //- .f-about
          .seo
            h4 About Us
            p
              | Welcome to EpicWin, home of a Magical Gaming Experience that will forever change how you Win!
              br
              | We welcome ONE and ALL into our realm. Come and discover for yourself the MAGIC of what we have to offer.
            #readmore.collapse
              template(v-if="metaData.length > 0")
                div(v-if="metaData[0].en_body" v-html="metaData[0].en_body")
              p.text-center
                iframe(src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3984.071293625022!2d101.5847189!3d3.0756352!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31cc4d0068778ce9%3A0x783382852975494f!2sEpicWin!5e0!3m2!1sen!2smy!4v1722308875027!5m2!1sen!2smy' width='450' height='450' allowfullscreen='allowfullscreen' referrerpolicy='no-referrer-when-downgrade' style='border: 0px;')
            button.btn-read-more.collapsed(type='button' data-bs-toggle='collapse' href='#readmore' aria-expanded='false' aria-controls='readmore')

</template>
<script>
import liveTrans from '@/components2/_liveTransaction.vue'
import slotLobby from '@/components2/_slot.vue'
import banner from '@/components2/_banner.vue'
// import livecasino from '@/views/default/_live.vue'
export default{
  components: {
    liveTrans,
    slotLobby,
    banner
    // livecasino
  },
  data(){
    return{
      feedback: {
        success: true,
        status: ""
      },
      currentPath: "",
      selectedTab: 0,
      depoAmount:"",
      targetAmount: "",
      depoProgress: "",
      // rayaAngpow: "",
      dataDay:[
        {day: "Day 1", claimed: "", ready: "",},
        {day: "Day 2", claimed: "", ready: "",},
        {day: "Day 3", claimed: "", ready: "",},
        {day: "Day 4", claimed: "", ready: "",},
        {day: "Day 5", claimed: "", ready: "",},
      ],
      metaData:[],
      liveFooter: false
    }
  },
  // metaInfo(){
  //   if(this.metaData.length> 0){
  //     return{
  //       title: this.metaData[0].meta_title || 'EpicWin Malaysia',
  //       meta:[
  //         { name: 'description',content: this.metaData[0].meta_desc },
  //         { name: "keywords", content: this.metaData[0].meta_keywords },
  //         { name: "author", content: this.metaData[0].meta_author },
  //         { name: "publisher", content: this.metaData[0].meta_publisher },

  //         { property: 'og:title', content: this.metaData[0].meta_title },
  //         { property: 'og:description', content: this.metaData[0].meta_desc },
          
  //       ],
  //       link: [
  //         { rel: 'canonical', href: this.metaData[0].meta_canonical }, // Sets the canonical URL
  //       ],
  //     }
  //   }else{
  //     return{
  //       title: 'EpicWin Malaysia',
  //       meta:[
  //         { name: 'description',content: 'EpicWin Malaysia' },
  //       ],
  //     }
  //   }
  // },
  computed:{
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getDisplayName() {
      return this.$store.getters.username || this.$store.getters.accountID
    },
    currentBalance() {
      return this.$store.getters.balance
    },
    getLanguage() {
      return this.$store.getters.language || "en"
    },
    getClaimed(){
      var count = this.dataDay.filter(item=> item.claimed === true).length;
      if(count < 4){
        return count * 25
      }else{
        return 100
      }
    },
    // rayaAngpow(){
    //   return this.$store.state.user.depositCount
    // },
    // spintokenBal(){
    //   return this.$store.state.user.spinToken
    // }
  },
  watch:{
    $route (to, from){
      this.currentPath = to.path
      this.showContent = this.$helpers.routeCheck(to.path)
      if(this.showContent === true){
        // this.cnyDeposit()
        this.missionDetails()
      }
      // if(to.path === '/promotions' || to.path === '/inbox' || to.path === '/profile'){
      //   this.showContent = false
      // }else{
      //   this.showContent = true
      // }
    },
    sessionToken(newState, oldState){
      if(newState === '' || newState === undefined){
        this.dataDay = [
          {day: "Day 1", claimed: "", ready: "", date:""},
          {day: "Day 2", claimed: "", ready: "", date:""},
          {day: "Day 3", claimed: "", ready: "", date:""},
          {day: "Day 4", claimed: "", ready: "", date:""},
          {day: "Day 5", claimed: "", ready: "", date:""},
        ]
        this.depoAmount = ""
      }else{
        // if(this.showContent === true){
          // this.cnyDeposit()
          this.missionDetails()
        // }
      }
    }
  },
  mounted(){
    this.checkWidth()
    var vm = this
    $(window).resize(function () {
      vm.checkWidth()
    });
    this.currentPath = this.$router.currentRoute.path
    if(this.isLoggedIn){
      // if(this.showContent === true){
        // this.cnyDeposit()
        this.missionDetails()
      // }
      
      // this.rayaDeposit()
      
    }
    $('.slot-slide').slick({
      infinite: true,
      arrows: true,
      slidesToShow: 6,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      
      responsive: [
        {
          breakpoint: 991,
        settings: {
        slidesToShow: 3,
        }
      },
        {
        breakpoint: 480,
          settings: {
          slidesToShow: 2,
        }
      }
      ]
    });	
    $('.gamenav-slide').slick({
      infinite: true,
      arrows: true,
      slidesToShow: 7,
      slidesToScroll: 7,
      autoplay: false,
      autoplaySpeed: 2000
    }); 
    // this.getSeo()
    
  },
  methods:{
    checkWidth(){
      if(window.innerWidth > 720){
        this.liveFooter = false
      }else{
        this.liveFooter = true
      }
    },
    toSlot(option){
      this.$router.push({
        name:"slot",
        params:{
          "custom": true,
          "target": option
        }
      }).catch(error =>{})
    },
    getSeo(){
			let page_name = "home"
      let domain_name = window.location.hostname
      // let domain_name = "member.epwuatmy788.com"
			this.$store
				.dispatch("user/getSeo", {page_name, domain_name})
				.then(response => {
					this.loading = false;
					this.feedback.success = response.success
					if (this.feedback.success == true) {
						if(response.data.length > 0){
							// this.$store.dispatch("user/seoInfo", response.data[0])
              this.metaData = response.data
						}
					} else {
						if((typeof response.status) != 'object'){
							this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
						}       
					}
				})
				.catch(response => {
					this.loading = false;
					var vm = this;
					if((typeof response.status) != 'object'){
						this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
					}
				});
		},
    switchTab(target){
      this.selectedTab = target
    },
    getUrl(){
      return window.location.hostname
    },
    getBalance() {
      if (this.sessionToken) {
        var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getBalance", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }              
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              // this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              clearInterval(this.refreshBalance)
              this.$swal({
                title: vm.$tc("ui.attention"),
                confirmButtonText: "OK",
                text: vm.$t("message.list." + response.status),
                type: "info"
              }).then(result => {
                this.$store
                  .dispatch("user/logout")
                  .catch(err => {})
              });
            }
            if(response?.status?.status == 0){
              console.log('Network Error')
            }
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();
          });
      }
    },
    missionDetails(){
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/missionDetails", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              // var temp = response.data.length
              this.dayComplete = response.data.length
              if(response.data.length > 0){
                var latestDate = this.$moment(response.data[this.dayComplete-1].deposit_date).format("YYYY-MM-DD")
                var currentDate = this.$moment(new Date()).format("YYYY-MM-DD")
                for(let i = 0; i < this.dayComplete; i++){
                  // if(this.depoAmount === ''){
                  //   this.depoAmount = response.data[i].deposit_amount
                  // }else{
                  //   this.depoAmount = this.depoAmount + response.data[i].deposit_amount
                  // }
                  this.dataDay[i].claimed = true
                  this.dataDay[i].date = this.$moment(response.data[i].deposit_date).format("MM/DD")
                  if(latestDate !== currentDate){
                    if(latestDate.localeCompare(currentDate) === -1 && (this.dayComplete-i === 1)){
                      if(i+1 < 5){
                        this.dataDay[i+1].ready=true
                      } 
                    }
                  }
                  if(this.$moment(response.data[i].deposit_date).format("YYYY-MM-DD") === this.$moment().format("YYYY-MM-DD")){/* daily event*/
                    this.depoAmount = response.data[i].deposit_amount
                  }
                }
                // this.targetAmount = 188 /* daily event*/
                // this.depoProgress = parseFloat(this.depoAmount) / this.targetAmount * 100 /* daily event*/
                // if(this.depoProgress > 100){
                //   this.depoProgress = 100
                // }
                // if(this.depoAmount >= 150 && this.depoAmount < 300){
                //   this.accuProgress = 100/6
                // }else if(this.depoAmount >= 300 && this.depoAmount < 1000){
                //   this.accuProgress = 100/6*2
                // }else if(this.depoAmount >= 1000 && this.depoAmount < 1500){
                //   this.accuProgress = 100/6*3
                // }else if(this.depoAmount >= 1500 && this.depoAmount < 3000){
                //   this.accuProgress = 100/6*4
                // }else if(this.depoAmount >= 3000 && this.depoAmount < 6000){
                //   this.accuProgress = 100/6*5
                // }else if(this.depoAmount >= 6000){
                //   this.accuProgress = 100
                // }else{
                //   this.accuProgress = 0
                // }
              }else{
                this.dataDay[0].ready = true
              }
              
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }              
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }  
          });
      }
    },
    triggerAction(target){
      // if(target === true){
      //   this.$router.push("deposit").catch(error =>{})
      // }
      this.$router.push("missions").catch(error =>{})
    },
  }
}
</script>